const messages = {
    en: {
      contibute: "Contribute",
      select: "Please select subject",
      addMyQuestions: "Add my questions",
      myQuestionsStatus: "My added questions' status",
      youCanAddQuestions: "On this page you can share your experience and add questions to our knowledge base. After checking by the moderator, they will be added and available to all users. Please note that maximum length of the answer or question is 1000 characters",
      onceAdded: "Please take into consideration that once added, you can't change or edit your question. To check your question details, just click question status",
      addSuccess: "Your question has been sent to moderation, thanks",
      addError: "Network error, please try again later",
      pleaseselectASubject: "Please select a subject",
      clickToSelect: "Please select subject",
      maximumNumberOfContributions: "Maximum number of questions",
      perDay: " per day"
    },
    ru: {
      contibute: "Мои вопросы",
      select: "Пожалуйста, выберите предмет",
      addMyQuestions: "Добавить вопросы",
      myQuestionsStatus: "Статус добавленных мной вопросов",
      youCanAddQuestions: "Hа этой страничке вы можете поделиться своим опытом и добавить в базу знаний вопросы. После проверки модератором они будут добавлены и доступны всем пользователям. Обратите внимание, что максимальная длина ответа или вопроса составляет 1000 символов.",
      onceAdded: "Учтите, что после добавления вы не можете изменить или отредактировать свой вопрос. Чтобы проверить детали своего вопроса, просто нажмите на статус вопроса.",
      addSuccess: "Ваш вопрос отправлен на модерацию, спасибо",
      addError: "Ошибка сети, повторите попытку позже",
      pleaseselectASubject: "Пожалуйста, выберите предмет",
      clickToSelect: "Пожалуйста, выберите предмет",
      maximumNumberOfContributions: "Максимальное количество вопросов",
      perDay: " в день"
    }
  };

  export default messages;